import { TableRow, TableCell } from "@mui/material";
import { format } from "date-fns";
import AdminDropdown from "app/partials/content/CustomDropdowns/AdminDropdown";
import Datatable from "app/partials/datatable/Datatable";
import { useAccountModel } from "./useAccountModel";
import { PatientAccountType } from "app/types";
import { ActionButtons } from "./components";
import { useState } from "react";

type AccountListViewProps = ReturnType<typeof useAccountModel>;

export const AccountListView = ({
  translate,
  handleChangeAccounts,
  accounts,
  headRows,
  endpoint,
  searchUserById,
}: AccountListViewProps) => {
  const [openedOptionsPatient, setOpenedOptionsPatient] = useState<boolean>(
    false,
  );

  const formatRow = (r: PatientAccountType) => {
    const toLinkDobleClick = () => {
      if (openedOptionsPatient) {
        setOpenedOptionsPatient(false);
        return;
      }
      window.location.href = `/admin/account/results/${r.accountId}`;
    };
    return (
      <TableRow
        hover
        tabIndex={-1}
        key={r.id}
        onClick={toLinkDobleClick}
        onDoubleClick={toLinkDobleClick}
      >
        <TableCell>
          <ActionButtons
            patient={r}
            setOpenedOptionsPatient={setOpenedOptionsPatient}
          />
        </TableCell>
        <TableCell scope="row">{r.name}</TableCell>
        <TableCell scope="row">{r.cpf}</TableCell>
        <TableCell>{r.email}</TableCell>
        <TableCell>{searchUserById(r.userId)}</TableCell>
        <TableCell>{format(new Date(r.createdAt), "dd/MM/yyyy")}</TableCell>
      </TableRow>
    );
  };

  return (
    <div className="account-list">
      <Datatable
        title={translate("screenApp.listPacient.account.titleList")}
        endpoint={endpoint}
        headRows={headRows}
        formatRow={formatRow}
        rows={accounts}
        setRows={handleChangeAccounts}
        reload={false}
        placeholderSearch={translate("screenApp.listPacient.SearchNameDoc")}
        mobile={AdminDropdown}
        width={window.innerWidth}
        isActive={"true"}
        buttons={[
          {
            label: translate("datatable.add"),
            onClick: null,
            icone: "add",
            path: "/admin/account/create",
          },
        ]}
        orderBy="Name"
        order="asc"
      />
    </div>
  );
};
